import { describeHelpers } from "../../../../../features/data-types"
import { showErrorStrToast, showToast } from "../../../../../features/ui"
import { useHoardService } from "../../../services/hoardService"
import { HoardOrder } from "../../../state/types"

export const useActions = () => {
    const { describeCode } = describeHelpers

    const { closeHoard } = useHoardService()

    const submitCloseHoard = async (
        hoard: HoardOrder,
        addCreditInFavor: boolean,
        onClosed?: () => Promise<void>
    ) => {
        try {
            await closeHoard(hoard.id, addCreditInFavor)
            showToast(`El Acopio ${describeCode(hoard)} fue cerrado.`)
            await onClosed?.()
        } catch (error) {
            showErrorStrToast('No se pudo cerrar el acopio.')
        }
    }

    return {
        submitCloseHoard
    }
}
